module.exports = __webpack_public_path__ + "img/regulations-and-tax-compliance.fc1ef8b6.svg";